/**
 * Shared processor health rules for the Device, Companion and Management apps.
 */

import CpuInfoDto from "../models/CpuInfoDto";

// The device script owns the percentage behind this, so both apps test the level it reported.
export const CPUDEGRADEDLEVEL = 3;

// The band between this and CPUDEGRADEDLEVEL is the script's warning band: no longer healthy, not
// yet degraded.
export const CPUHEALTHYLEVEL = 1;

// Kept here rather than in the device script, which on Windows ships outside the release.
export const CPUDEGRADEDMESSAGE = "The unit currently does not have the capability to perform this operation (possibly due to heat). Restart the unit. If this continues to occur, please contact Support.";

export function isCpuDegraded(info: CpuInfoDto|null): boolean {
    return (info?.WarningLevel ?? 0) >= CPUDEGRADEDLEVEL;
}

// Only a healthy reading counts as a recovery. A reading in the warning band is not one, so it must
// not re-arm the operator's warning.
export function isCpuHealthy(info: CpuInfoDto|null): boolean {
    return info?.WarningLevel === CPUHEALTHYLEVEL;
}
